import { render, staticRenderFns } from "./WebSettings.vue?vue&type=template&id=72de950a&"
import script from "./WebSettings.vue?vue&type=script&lang=js&"
export * from "./WebSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports